/**
 * Utility module for objects.
 */


/**
 * Class for object-related functionality.
 *
 * @class      Objects (name)
 */
export default class Objects
{
	/**
	 * Checks if an object property is set to avoid the hassle of having lots of
	 * typeof checks.
	 *
	 * @param      {Function}  functionWithValues  A function that returns the
	 *                                             value we're searching for
	 * @return     {boolean}   True if value could be found, false otherwise
	 */
	static isset( functionWithValues = () => { return undefined; } )
	{
		// Set a variable we can modify later
		let value;

		try
		{
			// Try to get the values
			value = functionWithValues();
		}
		catch ( err )
		{
			// Set to undefined if something went wrong
			value = undefined;
		}
		finally
		{
			// Return whether it could be found or not
			return ( value !== undefined );
		}
	}
};



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/utility/objects/objects.js